import React, { useCallback, useRef, useState, useEffect } from 'react';
import { VariableSizeList as List } from 'react-window';
import { useWindowResize } from 'utils/useWindowResize';
import TableRow from './TableRow';

const Row = ({
	data,
	index,
	setSize,
	windowWidth,
	companies,
	spendFormatter,
	onItemChange,
	onGroupItemChange,
	items,
	highlightId,
	segments,
	showSegments,
	itemsType,
	showTopVendors,
	onTailItemsChange,
}) => {
	const rowRef = useRef();

	useEffect(
		() => {
			setSize(index, rowRef.current.getBoundingClientRect().height);
		},
		[setSize, index, windowWidth]
	);

	return (
		<div ref={rowRef}>
			<TableRow
				data={data[index]}
				companies={companies}
				spendFormatter={spendFormatter}
				onItemChange={onItemChange}
				onGroupItemChange={onGroupItemChange}
				items={items}
				highlightId={highlightId}
				segments={segments}
				showSegments={showSegments}
				itemsType={itemsType}
				showTopVendors={showTopVendors}
				onTailItemsChange={onTailItemsChange}
			/>
		</div>
	);
};

export const VirtualList = ({
	data,
	companies,
	spendFormatter,
	onItemChange,
	onGroupItemChange,
	items,
	highlightId,
	wrapperRef,
	headerRef,
	segments,
	showSegments,
	itemsType,
	showTopVendors,
	onTailItemsChange,
}) => {
	const listRef = useRef();
	const listOuteRef = useRef();
	const sizeMap = useRef({});
	const [height, setHeight] = useState(0);
	const [windowWidth, windowHeight] = useWindowResize();
	const setSize = useCallback((index, size) => {
		sizeMap.current = { ...sizeMap.current, [index]: size };
		listRef.current.resetAfterIndex(index);
	}, []);
	const getSize = index => sizeMap.current[index] || 42;
	const scrollToItem = useCallback(
		() => {
			if (listRef && listRef.current) {
				const index = data.findIndex(item => item.id === highlightId);

				listRef.current.scrollToItem(index, 'center');
			}
		},
		[listRef, highlightId, data]
	);

	useEffect(
		() => {
			if (wrapperRef && wrapperRef.current) {
				setHeight(wrapperRef.current.clientHeight);
			}
		},
		[wrapperRef, windowHeight]
	);

	useEffect(
		() => {
			const headerEl = headerRef.current;
			const listEl = listOuteRef.current;

			if (headerEl && listEl) {
				listEl.addEventListener(
					'scroll',
					e => {
						headerEl.scrollLeft = e.target.scrollLeft;
					},
					{ passive: true }
				);
			}
		},
		[headerRef, listOuteRef]
	);

	useEffect(
		() => {
			if (highlightId) {
				scrollToItem();
			}
		},
		[highlightId, scrollToItem]
	);

	return (
		<List
			ref={listRef}
			outerRef={listOuteRef}
			height={height}
			width="100%"
			itemCount={data.length}
			itemSize={getSize}
			itemData={data}
			style={{ overflow: 'auto overlay' }}
		>
			{({ data, index, style }) => (
				<div style={style}>
					<Row
						data={data}
						index={index}
						setSize={setSize}
						windowWidth={windowWidth}
						companies={companies}
						spendFormatter={spendFormatter}
						onItemChange={onItemChange}
						onGroupItemChange={onGroupItemChange}
						items={items}
						highlightId={highlightId}
						segments={segments}
						showSegments={showSegments}
						itemsType={itemsType}
						showTopVendors={showTopVendors}
						onTailItemsChange={onTailItemsChange}
					/>
				</div>
			)}
		</List>
	);
};
